// extracted by mini-css-extract-plugin
export default {"container":"MobileControls_container__518NR","playButton":"MobileControls_playButton__FF2lk"};